import 'datatables.net-dt/js/dataTables.dataTables.min.js'
import 'datatables.net-colreorder-dt/js/colReorder.dataTables.js'
import 'datatables.net-fixedcolumns-dt/js/fixedColumns.dataTables.js'
import 'datatables.net-fixedheader-dt/js/fixedHeader.dataTables.js'
import 'datatables.net-rowreorder-dt/js/rowReorder.dataTables.js'

jQuery(document).ready(function ($) {
  //Scroll right button
  $('.scroll-right').click(function() {
    $('.dataTables_scrollBody').animate({scrollLeft: '+=374px'}, '300');
  });

  //Scroll left button
  $('.scroll-left').click(function() {
    $('.dataTables_scrollBody').animate({scrollLeft: '-=374px'}, '300');
  });

  // eslint-disable-next-line no-undef
  var pllLang = pll;
  var searchPlaceholder;
  var emptyTable;
  var info;
  var infoEmpty;
  var infoFiltered;
  var lengthMenu;
  var previousStickyIndex;
  var previousStickies;

  switch (true) {

    case (pllLang === 'nl'):
      searchPlaceholder = 'Filter op zoekwoord...';
      emptyTable = 'Geen data beschikbaar';
      info = '_START_ tot _END_ van de _TOTAL_ records';
      infoEmpty = '0 tot 0 van de 0 records';
      infoFiltered = '(gefilterd van _MAX_ totale records)';
      lengthMenu = 'Toon _MENU_ records';
      break;
    case (pllLang === 'en'):
      searchPlaceholder = 'Filter by search...';
      emptyTable = 'No data available in table';
      info = 'Showing _START_ to _END_ of _TOTAL_ entries';
      infoEmpty = 'Showing 0 to 0 of 0 entries';
      infoFiltered = '(filtered from _MAX_ total entries)';
      lengthMenu = 'Show _MENU_ entries';
      break;
    case (pllLang === 'de'):
      searchPlaceholder = 'Nach Schlüsselwort filtern...';
      emptyTable = 'Keine Daten in der Tabelle verfügbar';
      info = 'Anzeigen von _START_ bis _END_ von _TOTAL_ Einträgen';
      infoEmpty = '0 bis 0 von 0 Einträgen anzeigen';
      infoFiltered = '(gefiltert aus _MAX_ Gesamteinträgen)';
      lengthMenu = '_MENU_ Einträge anzeigen';
      break;
  }

  function bindEvents() {
    $('.pinrow').unbind('click');
    $('.pinrow').click(moveRow);

    $('.pincol').unbind('click');
    $('.pincol').click(moveCol);
  }

  function createTable() {
    var tableX = $('.experience-overview-table__table').removeAttr('width').DataTable({
      columnDefs: [
        {
          targets: ['idcol'],
          orderable: true,
          visible: false,
          searchable: false,
        }, {
          targets: ['carcol'],
          orderable: false,
          visible: true,
          width: 300,
        }, {
          targets: ['_all'],
          orderable: false,
          visible: true,
          width: 150,
        },
      ],
      fixedColumns: {
        //leftColumns: $('.stickycol').length + 2,
        leftColumns: 2,
      },
      scrollX: true,
      //scrollY: 600,
      scrollCollapse: true,
      colReorder: true,
      paging: false,
      info: false,
      searching: false,
      language: {
        search: '<i class="fa fa-filter" aria-hidden="true"></i>',
        searchPlaceholder: searchPlaceholder,
        paging: false,
        emptyTable: emptyTable,
        info: info,
        infoEmpty: infoEmpty,
        infoFiltered: infoFiltered,
        lengthMenu: lengthMenu,
      },
    });
    bindEvents();
    return tableX;
  }

  var table = createTable();

  $('th[data-column-index]').each(
    function () {
      $(this).attr('original-index', $(this).attr('data-column-index'));
    }
  );

  function moveRow() {

    previousStickies = [];
    var row = $(this).parents('tr');
    var index = table.row(row).index();
    var data1 = table.row(index).data();
    var wasSticky = row.hasClass('sticky');
    data1[0] = -data1[0];

    // Grab previous sticky rows.
    $('tr[data-dt-row]').each(function () {
      if ($(this).hasClass('sticky')) {
        previousStickyIndex = $(this).attr('data-dt-row');
        if (previousStickyIndex != index) {
          previousStickies.push(previousStickyIndex);
        }
      }
    });

    table.row(index).data(data1).draw();
    bindEvents();
    checkSticky(index, wasSticky, previousStickies);
  }

  function checkSticky(index, wasSticky, previousStickies) {

    previousStickies = previousStickies || [];
    index = index || null;
    wasSticky = wasSticky || null;

    $.each(previousStickies, function (index, value) {
      $('*[data-dt-row="' + value + '"]').addClass('sticky')
    });

    if (index) {
      $('*[data-dt-row="' + index + '"]').each(function () {
        if (wasSticky) {

          $(this).removeClass('sticky');
        } else {
          $(this).addClass('sticky');
        }
      });
    }
  }

  function moveCol() {

    previousStickies = [];

    // Grab previous sticky rows, preserve their sticky state.
    $('tr[data-dt-row]').each(function () {
      if ($(this).hasClass('sticky')) {
        previousStickyIndex = $(this).attr('data-dt-row');
        previousStickies.push(previousStickyIndex);
      }
    });

    var col = $(this).parents('th');
    var index = parseInt(col.attr('data-column-index'));
    //var index     = table.column(col).index();
    var colLength = table.colReorder.order().length;
    var orgindex = $(col).attr('original-index');

    var colOrder = [];
    for (var i = 0; i <= colLength - 1; i++) {
      colOrder.push(i);
    }

    if (col.hasClass('stickycol')) {

      $('th[original-index="' + orgindex + '"]').removeClass('stickycol');

      colOrder = jQuery.grep(colOrder, function (value) {
        return value != index;
      });

      var newColOrder = [];

      $.each(colOrder, function (key, value) {

        newColOrder.push(value);

        if (value == orgindex) {
          newColOrder.push(index);
        }
      });

      table.colReorder.order(newColOrder, false);

      table.destroy();

      table = createTable();

    } else {
      $(col).addClass('stickycol');

      colOrder = jQuery.grep(colOrder, function (value) {
        return value != index;
      });

      colOrder = jQuery.grep(colOrder, function (value) {
        return value != 0;
      });

      colOrder = jQuery.grep(colOrder, function (value) {
        return value != 1;
      });

      colOrder.unshift(0, 1, index);

      table.colReorder.order(colOrder, false);

      table.destroy();

      table = createTable();

    }

    checkSticky(null, null, previousStickies);
  }
});



// WEBPACK FOOTER //
// ./scripts/experience-overview-table.js